<template>
  <v-container id="force-stop-dialog">
    <v-dialog v-model="openDialog" max-width="600px">
      <v-card class="py-6">
        <v-card-title class="justify-center black--text">주행을 강제 종료하시겠습니까?</v-card-title>
        <v-card-subtitle class="text-center mt-2">도착 시간은 강제 종료 시간으로, <br> 주행 거리는 예상 주행 거리로 저장됩니다.</v-card-subtitle>
        <v-divider class="my-2"></v-divider>

        <v-card-text>
          <v-row class="align-center mx-4">
            <v-col cols="12" class="mx-0 px-0 black--text title">요금 결제</v-col>
            <v-col cols="4">주행 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.driveFee" suffix="원" :rules="[rules.numberOnly]" dense filled></v-text-field>
            </v-col>

            <v-col cols="4">대기 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.waitFee"suffix="원" :rules="[rules.numberOnly]" dense filled></v-text-field>
            </v-col>

            <v-col cols="4">도움서비스 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.serviceFee"suffix="원" :rules="[rules.numberOnly]" dense filled></v-text-field>
            </v-col>

            <v-col cols="4">추가 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.extraFee"suffix="원" :rules="[rules.numberOnly]" dense filled></v-text-field>
            </v-col>

            <v-col cols="4" class="mx-0 px-0 black--text title">최종 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.totalFee = calcTotalFee"suffix="원"  dense flat solo  class="ma-0 pa-0"></v-text-field>
            </v-col>

            <v-col cols="4" class="mx-0 px-0 black--text title">실 결제 요금</v-col>
            <v-col cols="8">
              <v-text-field v-model="paymentInfo.paidFee" suffix="원" :rules="[rules.numberOnly]" dense filled></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>

          <v-row class="align-center mx-4">
            <v-col cols="12" class="mx-0 px-0 black--text title">결제 수단</v-col>
            <v-col cols="12">
              <v-radio-group row dense hide-details v-model="paymentInfo.payMethod" mandatory>
                <v-radio v-for="item in payMethodGroup" :label="item.label" :value="item.value">
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <c-btn color="grey" outlined @click="onCloseForceStopDialog">취소</c-btn>
          <c-btn color="blue" outlined @click="onConfirmForceStop"> 확인</c-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "ForceStopDialog",
  props: {
    openDialog : {
      type: Boolean,
      default : false,
    },
    expectedDriveFee: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      isOpen: false,
      rules: {
        numberOnly: value => /^[0-9]*$|^null$/.test(value) || '숫자만 입력해주세요',
      },
      payMethodGroup: [
        {label : '현금으로 직접 결제', value:'pm_cash'}
      ],
      paymentInfo: {
        driveFee: 0,
        waitFee: 0,
        serviceFee: 0,
        extraFee: 0,
        totalFee: 0,
        paidFee: 0, //실 결제 요금
        payMethod : null,
      },
    }
  },
  watch: {
    expectedDriveFee(val) {
      if(val) {
        this.paymentInfo.driveFee = val;
      }
    }
  },
  methods: {
    onCloseForceStopDialog() {
      //clear form
      this.paymentInfo = {
        driveFee: this.expectedDriveFee,
        waitFee: 0,
        serviceFee: 0,
        extraFee: 0,
        totalFee: 0,
        paidFee: 0,
        payMethod: null,
      }
      this.$emit('update:openDialog' ,false)
    },
    onConfirmForceStop() {
      if(this.checkInputField() && this.checkIsNumberOnly()) {
        this.$emit('reqForceStop', this.paymentInfo)
        this.onCloseForceStopDialog();
      }
    },
    checkInputField() {
      if(this.paymentInfo.driveFee === ''
          || this.paymentInfo.waitFee === ''
          ||  this.paymentInfo.serviceFee === ''
          ||  this.paymentInfo.extraFee === ''
          || this.paymentInfo.paidFee === '' ) {
        this.$store.commit('snackbar', {msg: '비어있는 필드가 있습니다.'})
        return false
      }
      return true;
    },
    checkIsNumberOnly() {
      if(isNaN(this.paymentInfo.driveFee)
          || isNaN(this.paymentInfo.waitFee)
          || isNaN(this.paymentInfo.serviceFee)
          || isNaN(this.paymentInfo.extraFee)
          || isNaN(this.paymentInfo.paidFee)) {
        this.$store.commit('snackbar', { msg: '숫자만 입력해주세요.'});
        return false;
      }
      return true;
    },
  },
  computed:{
    calcTotalFee() {
      const total = Number(this.paymentInfo.driveFee) + Number(this.paymentInfo.waitFee) + Number(this.paymentInfo.serviceFee) + Number(this.paymentInfo.extraFee);
      return isNaN(total) ? '-' : total
    },
  },
}
</script>

<style scoped>

</style>